/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Ad_Trim_To_DurationInputs */



/**
* | output |
* | --- |
* | "Trim To Audio Duration" |
*
* @param {Shortcut_Keys_Name_Ad_Trim_To_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_ad_trim_to_duration = /** @type {((inputs?: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Ad_Trim_To_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Adapter a la duree audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Audiodauer zuschneiden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ritaglia in base alla durata audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обрезать до длительности звука")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recortar a la duración del audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("裁剪至音频时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオの長さに合わせてトリム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो की अवधि के अनुसार ट्रिम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cortar para a duração do áudio")
	return /** @type {LocalizedString} */ ("Trim To Audio Duration")
});